import "./jquery-global.js";
import $ from "jquery";
import 'fomantic-ui-css/semantic.min.js';
import * as contentFR from './content-FR.js';
import * as contentEN from './content-EN.js';
import contentPusher from './content-pusher.js';

export default () => {

  $(document).ready(function () {

    if (window.location.pathname.indexOf("index_EN.html") != -1 ) {
      contentPusher(contentEN.texts, contentEN.demoTexts);
    }
    else {
      contentPusher(contentFR.texts, contentFR.demoTexts);
    }

    // UI Component
    const sidebar = $('.sidebar');
    const previousButton = $('.go-to-previous');
    const nextButton = $('.go-to-next');
    const openMenuButton = $('.open-sidebar');
    const closeMenuButton = $('.close-sidebar');
    const infoTriggers = $('.info-trigger:not(.has-modal)');
    const infoTriggersModal = $('.info-trigger.has-modal');
    const menuItems = $('a.item');
    const titles = $('.title');
    const categoryDropdown = $('.ui.dropdown');
    const openingModal = $('.opening-modal');
    const modalCategoryButton = $('.opening-modal [data-category-trigger]');
    const homeButton = $('.go-to-home');
    let visibleSlide = $('.single-slide.visible');
    let targetLabel = null;
    let menuTarget = null;
    let currentTitle = null;
    let currentTitleTarget = null;

    // CUSTOM FUNCTIONS
    function goToPrevious() {
      if (visibleSlide.hasClass('first')) {
        return false;
      } else {
        infoTriggers.popup('hide');
        visibleSlide.removeClass('visible').prev('.single-slide').addClass('visible');
        visibleSlide = $('.single-slide.visible');
      }
      switchTitle();
      navChecker();
    }

    function goToNext() {
      if (visibleSlide.hasClass('last')) {
        return false;
      } else {
        infoTriggers.popup('hide');
        visibleSlide.removeClass('visible').next('.single-slide').addClass('visible');
        visibleSlide = $('.single-slide.visible');
      }
      switchTitle();
      navChecker();
    }

    function goToSlide(e) {
      targetLabel = $(e.target).attr('data-target');
      menuTarget = $('.single-slide[data-id=' + targetLabel + ']');
      if (menuTarget === visibleSlide) {
        return false;
      } else {
        visibleSlide.removeClass('visible');
        menuTarget.addClass('visible');
        visibleSlide = $('.single-slide.visible');
        sidebar.sidebar('hide');
        switchTitle();
        navChecker();
      }
    }

    function goToFirst(slide) {
      visibleSlide.removeClass('visible');
      slide.addClass('visible');
      visibleSlide = $('.single-slide.visible');
      switchTitle();
      navChecker();
    }

    function navChecker() {
      if (visibleSlide.hasClass('first')) {
        previousButton.addClass('invisible');
      } else if (previousButton.hasClass('invisible')) {
        previousButton.removeClass('invisible');
      }
      if (visibleSlide.hasClass('last')) {
        nextButton.addClass('invisible');
      } else if (nextButton.hasClass('invisible')) {
        nextButton.removeClass('invisible');
      }
    }

    function switchTitle() {
      currentTitleTarget = $('.single-slide.visible').attr('data-id');
      currentTitle = $('.title[data-title="' + currentTitleTarget + '"]');
      titles.removeClass('current-title');
      currentTitle.addClass('current-title');
    }

    // SIDEBAR
    openMenuButton.click(function () {
      sidebar.sidebar('show');
    });

    // ASIDE MENU
    closeMenuButton.click(function () {
      sidebar.sidebar('hide');
    });

    // Slide Navigation
    previousButton.click(function () {
      goToPrevious();
    });

    nextButton.click(function () {
      goToNext();
    });

    menuItems.click(function (e) {
      goToSlide(e);
    });

    homeButton.click(function () {
      sidebar.sidebar('hide');
      openingModal.addClass('visible');
    });

    // CATEGORY SWITCHER - in modal
    modalCategoryButton.click(function () {
      const currentCategoryTrigger = $(this);
      const currentCategory = currentCategoryTrigger.attr('data-category-trigger');
      const printLink = $('.print-trigger a');
      const prevCategory = $('[data-category]:not(.hidden)');
      const target = $('[data-category=' + currentCategory + ']');
      const firstSlide = $('[data-category=' + currentCategory + '] .first');

      prevCategory.addClass('hidden');
      target.removeClass('hidden');
      $('.pusher .categories .ui.button[data-category-trigger=' + currentCategory + ']').addClass('active');
      categoryDropdown.dropdown('set selected', currentCategory);
      openingModal.removeClass('visible');
      goToFirst(firstSlide);
    });

    categoryDropdown.dropdown({
      onChange: function (value) {
        const currentCategory = value;
        const printLink = $('.print-trigger a');
        const prevCategory = $('[data-category]:not(.hidden)');
        const target = $('[data-category=' + currentCategory + ']')
        const firstSlide = $('[data-category=' + currentCategory + '] .first');

        prevCategory.addClass('hidden');
        target.removeClass('hidden');
        $('.pusher .categories .ui.button[data-category-trigger=' + currentCategory + ']').addClass('active');
        goToFirst(firstSlide);
      },
    });

    $(document).bind("keydown", function (e) {

      // PRINT
      if (e.ctrlKey && e.keyCode == 80) {
        const printLink = $('.print-trigger a').attr('href');
        window.open(
          printLink,
          '_blank'
        );
        return false;
      }

      // Navigation (with arrows)
      if (e.keyCode == 37) { goToPrevious(); }
      if (e.keyCode == 39) { goToNext(); }
    });



    infoTriggers.popup({
      on: 'click'
    });

    infoTriggersModal.popup({
      on: 'click'
    });

    infoTriggersModal.click(function (e) {
      const button = $(e.target);
      const target = button.attr('data-target');
      button.popup('show');
      const popup = $('.ui.popup');
      popup.addClass('has-modal');
      popup.append('<div class="modal-trigger" data-target="' + target + '"><i class="material-icons">add_circle</i></div>');
      $('.modal-trigger').click(function () {
        const button = $(this);
        const target = button.attr('data-target');
        $('.ui.modal[data-id=' + target + ']').modal('show');
      });
    });

    setTimeout(function () {
      openingModal.addClass('active');
    }, 200);

    $('.ui.modal').modal();

  });

};